import { render } from "./EFTDepositComponent.vue?vue&type=template&id=b1dbfc2c&ts=true"
import script from "./EFTDepositComponent.vue?vue&type=script&lang=ts"
export * from "./EFTDepositComponent.vue?vue&type=script&lang=ts"

import "./EFTDepositComponent.vue?vue&type=style&index=0&id=b1dbfc2c&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/buyCrypto/EFTDepositComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b1dbfc2c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b1dbfc2c', __exports__)) {
    api.reload('b1dbfc2c', __exports__)
  }
  
  module.hot.accept("./EFTDepositComponent.vue?vue&type=template&id=b1dbfc2c&ts=true", () => {
    api.rerender('b1dbfc2c', render)
  })

}


export default __exports__